import React, { FC } from 'react';
import { useAvailableTabIds } from './hooks/useAvailableTabIds';
import { TabChangeHandler, TabId } from './types';
import { createProvider } from '../../utils/createProvider';
import { useFallbackTab } from './hooks/useFallbackTab';

export type TabsProps = {
	activeTab: TabId;
	onTabChange: TabChangeHandler;
	className?: string;
	dataTestId?: string;
};

const [Provider, useTabsWrapperProvider] = createProvider<TabsProps>({
	contextName: 'TabsContext',
});

/**
 * Wrapper of other tab components (TabList, Tab(s), TabPanel(s))
 */
const Tabs: FC<React.PropsWithChildren<TabsProps>> = ({ activeTab, onTabChange, className, dataTestId, children }) => {
	const availableTabIds = useAvailableTabIds(children);

	useFallbackTab({
		activeTab,
		availableTabIds,
		selectHandler: onTabChange,
	});

	return (
		<Provider
			value={{
				activeTab,
				onTabChange,
			}}
		>
			<div
				data-testid={dataTestId}
				className={className}
				data-layout-component='tabs'
			>
				{children}
			</div>
		</Provider>
	);
};

export { Tabs, useTabsWrapperProvider };
